/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "@app/@core/services";
import { SessionStorageService } from "@app/@core/services/session-storage";

@Component({
  selector: "app-verify-google2fa",
  templateUrl: "./verify-google2fa.component.html",
  styleUrls: ["./verify-google2fa.component.scss"],
})
export class Google2FAComponent {
  otp: String = "";
  otp_length: number = 6;
  valid: boolean = false;
  processing: boolean = false;

  code_checked: boolean = false;
  code_verified: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionStorageService: SessionStorageService
  ) {
    this.sessionStorageService.removeItem("google-2fa");
  }

  submit() {
    this.processing = true;
    this.authService.checkGoogle2FA(this.otp).then((res) => {
      if (res["error"] === false) {
        this.code_verified = true;
      } else {
        if (res["message"] && res["message"].includes("unauthenticated_user")) {
          this.authService.invalidate();
        } else if (res["message"] && res["message"].includes("google-2fa-invalid")) {
          this.code_verified = false;
        }
      }

      this.code_checked = true;
      this.processing = false;
    });
  }

  otpChanged(evt) {
    this.code_checked = false;
    this.code_verified = false;

    if (evt !== this.otp) {
      this.otp = evt;
      this.processing = false;
      this.valid = this.otp_length == evt.length;

      if (this.valid) this.submit();
    }
  }
}
